<template>
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11.75" cy="11" r="10.25" fill="black" stroke="black" stroke-width="1.5"/>
    <path d="M11.0154 7.21942C11.0154 6.54742 11.5614 6.08542 12.2474 6.08542C12.9334 6.08542 13.4794 6.54742 13.4794 7.21942C13.4794 7.89142 12.9334 8.36742 12.2474 8.36742C11.5614 8.36742 11.0154 7.89142 11.0154 7.21942ZM11.2254 9.64142L13.2694 9.64142L13.2694 16.0814L11.2254 16.0814L11.2254 9.64142Z" fill="white"/>
  </svg>
</template>